// removed by extract-text-webpack-plugin
module.exports = {"featureSection":"wsNv57ONI3m8evJ59c75J","trafficBox":"_3kBkr2i534OXL-vYZduZcH","trafficBig":"_23FmaJ9wXOLKFgrUhAgsKV","syndicateSection":"_1XDAG9Gvd-TnjNxrXSgb69"};


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/components/snapsell/FeaturesSection.scss
// module id = 1603
// module chunks = 0